// @ts-nocheck
import { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Button } from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'
import { FormInput } from '../../generic'

export default class PasswordEditField extends Component {
  state = {
    isShowingInputs: false,
  }

  cancelEdit = () => {
    this.props.onCancel()
    this.toggleDisplay()
  }

  toggleDisplay = () => {
    this.setState((prevState) => ({
      isShowingInputs: !prevState.isShowingInputs,
    }))
  }

  renderInputs = () => {
    const { buttonText, errors, keys, onChange, placeholders, values } =
      this.props
    const { isShowingInputs } = this.state
    const firstKey = keys[0]
    const lastKey = keys[1]
    const firstKeyError = get(errors, firstKey)
    const lastKeyError = get(errors, lastKey)

    if (isShowingInputs) {
      return (
        <div style={styles.inputs}>
          <FormInput
            error={firstKeyError}
            onChange={(e) => onChange({ key: firstKey, value: e.target.value })}
            placeholder={placeholders ? placeholders[0] : 'New password'}
            style={{ ...styles.input, marginRight: 5 }}
            type="password"
            value={get(values, firstKey)}
            data-testid={
              this.props['data-testid']
                ? `${this.props['data-testid']}-new`
                : undefined
            }
          />
          <FormInput
            error={lastKeyError}
            onChange={(e) => onChange({ key: lastKey, value: e.target.value })}
            placeholder={placeholders ? placeholders[1] : 'Confirm password'}
            style={{ ...styles.input, margin: '0px 5px' }}
            type="password"
            value={get(values, lastKey)}
            data-testid={
              this.props['data-testid']
                ? `${this.props['data-testid']}-confirm`
                : undefined
            }
          />
          <Button
            variant="default"
            id="cancel-change-password"
            onClick={this.cancelEdit}
            style={{ ...styles.button, marginLeft: 5 }}
          >
            Cancel
          </Button>
        </div>
      )
    }
    return (
      <Button
        variant="default"
        id="change-password"
        onClick={this.toggleDisplay}
        style={styles.button}
      >
        {buttonText || 'Change Password'}
      </Button>
    )
  }

  render() {
    const { label, note, required } = this.props
    return (
      <div
        style={{
          ...styles.wrapper,
        }}
      >
        <div style={styles.labelWrapper}>
          <div style={styles.label}>
            {label} {required && <span style={{ color: colors.red }}>*</span>}
          </div>
        </div>
        <div style={styles.inputWrapper}>
          {this.renderInputs()}
          {note && <div style={styles.note}>{note}</div>}
        </div>
      </div>
    )
  }
}

PasswordEditField.propTypes = {
  onCancel: PropTypes.func.isRequired,
}

const styles = {
  button: {
    color: colors.black,
    textShadow: 'none',
  },
  input: {
    width: '100%',
  },
  inputs: {
    display: 'flex',
    flexDirection: 'row',
  },
  inputWrapper: {
    flex: 3,
    minWidth: 240,
  },
  label: {
    fontWeight: 600,
    marginRight: 5,
    paddingTop: 7,
  },
  labelWrapper: {
    display: 'flex',
    flex: 1,
    flexFlow: 'row wrap',
    marginRight: 30,
    minWidth: 160,
    paddingBottom: 5,
  },
  note: {
    color: colors.darkgrey,
    fontSize: 13,
    paddingTop: 5,
  },
  wrapper: {
    display: 'flex',
    flexFlow: 'row wrap',
    width: '100%',
  },
}
